export function translatePsCcError(error: string) {
  switch (error) {
    case 'INVALID_HOLDER':
      return 'Nome do titular inválido!'
    default:
      return error
  }
}
